import { featureItems } from "@/mocks/categories";

export default function FeaturesSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-xs font-semibold uppercase tracking-wider text-accent-600 whitespace-nowrap">Why Choose Us</span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mt-3 mb-3">
            Why Millions Of Users Prefer Superbuy Spreadsheet Style Research
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            Discover the advantages that make structured spreadsheet research the smart way to shop online.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="group p-6 md:p-7 rounded-lg bg-background-50 border border-background-200/60 hover:border-accent-200/60 transition-all duration-200"
            >
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-50 text-accent-600 mb-4 group-hover:scale-110 transition-transform duration-200">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <h3 className="text-base font-semibold text-foreground-950 mb-2 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}